
import { get, post, postImg } from "@/util/http"
import ApiContainer from "../url"
const visitApi = {
  getScenicVisitList: params => get(ApiContainer.getScenicVisitList, params),  //获取场馆列表
  queryVisitDetailsById: params => get(ApiContainer.queryVisitDetailsById, params),//获取旅行攻略列表接口
  updateScenicVisit:params=>post(ApiContainer.updateScenicVisit,params),//更新旅行攻略
}
export default visitApi